import React, { useMemo, useState } from 'react';

import moment from 'moment';

import InsightsApi from 'api/InsightsApi';
import useResolveHandler from 'Shared/useResolveHandler';

const SubscriptionsContext = React.createContext({});

const SubscriptionsContextProvider = (props) => {
  const targetsProps = { ...props };
  const [selectedRange, setSelectedRange] = useState({
    start: moment().subtract(4, 'month'),
    rangeMin: null,
    rangeMax: moment().add(5, 'years'),
    months: [],
    loading: false,
  });

  const { responseStatus, setStatus } = useResolveHandler();

  const [selectedMonth, setSelectedMonth] = useState(moment().format('YYYY-MM'));

  const onChangeRange = (direction) => {
    const rangeState = { ...selectedRange };

    rangeState.start =
      direction === 'next' ? rangeState.start.clone().add(9, 'month') : rangeState.start.clone().subtract(9, 'month');

    setSelectedRange(rangeState);
  };

  const getSubscriptions = (start, end) => {
    setSelectedRange((prevState) => ({ ...prevState, loading: true }));
    InsightsApi.getSubscriptionsMonthsByRange(start, end)
      .then((res) => {
        setSelectedRange((prevState) => ({ ...prevState, loading: false, months: res.data.items }));
      })
      .catch(() => setSelectedRange((prevState) => ({ ...prevState, loading: false })));
  };

  const value = useMemo(
    () => ({
      selectedMonth,
      setSelectedMonth,
      selectedRange,
      getSubscriptions,
      onChangeRange,
      setStatus,
    }),
    [selectedMonth, selectedRange, responseStatus]
  );

  return (
    <SubscriptionsContext.Provider value={value}>
      {targetsProps ? targetsProps.children : false}
    </SubscriptionsContext.Provider>
  );
};

export { SubscriptionsContext, SubscriptionsContextProvider };
